import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ColDef} from 'ag-grid-community';
import {IAdvancedFilterGroup} from '../../../../../features/settings-new/models/general/advanced-filter-group.interface';
import {
  matchesAdvancedFilterGridCategory,
} from '../../../../../features/settings-new/models/general/advanced-filter-grid.constants';
import {Store} from '@ngrx/store';
import {firstValueFrom, Observable} from 'rxjs';
import {
  selectAdvancedFilterGroupsBySelectedGrid,
  selectAppliedAdvancedFilterGroup,
  selectIsAdvancedFilterGroupsLoading,
  selectSelectedAdvancedFilterGroup
} from '../../../../../features/core/store-shared-filter/shared-filter.selectors';
import {setSelectedAdvancedFilterGroup} from '../../../../../features/core/store-shared-filter/shared-filter.actions';
import {ISharedModalFiltersAdvanced} from 'src/app/shared/shared-models/modals/shared-modal-filters-advanced';
import {selectFiltersForUserSelectedStore} from '../../../../../features/stock-manager/store/stock-manager.selectors';
import {ISearchableFields} from '../../../../shared-models/type-sense/default-searchable-fields';

@Component({
    selector: 'app-shared-modal-filters-advanced-container',
    templateUrl: './shared-modal-filters-advanced-container.component.html',
    styleUrls: ['./shared-modal-filters-advanced-container.component.scss'],
    standalone: false
})
export class SharedModalFiltersAdvancedContainerComponent implements ISharedModalFiltersAdvanced, OnInit {

  @Input() buttonCloseCross: boolean;
  @Input() colDefs: ColDef[];
  @Input() colDefsIgnore: string[];
  @Input() gridReference: string;
  @Input() modalTitle: string;
  @Input() lockCategoryTabs = false;

  advancedFilterGroups$: Observable<IAdvancedFilterGroup[]>;
  appliedAdvancedFilterGroup$: Observable<IAdvancedFilterGroup>;
  isAdvancedFilterGroupsLoading$: Observable<boolean>;
  selectedAdvancedFilterGroup$: Observable<IAdvancedFilterGroup>;
  selectedStoreFilters$: Observable<Record<string, ISearchableFields>>;

  constructor(
    private cdr: ChangeDetectorRef,
    private readonly store: Store
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.cdr.detectChanges();
    this.advancedFilterGroups$ = this.store.select(selectAdvancedFilterGroupsBySelectedGrid);
    this.appliedAdvancedFilterGroup$ = this.store.select(selectAppliedAdvancedFilterGroup);
    this.isAdvancedFilterGroupsLoading$ = this.store.select(selectIsAdvancedFilterGroupsLoading);
    this.selectedAdvancedFilterGroup$ = this.store.select(selectSelectedAdvancedFilterGroup);
    this.selectedStoreFilters$ = this.store.select(selectFiltersForUserSelectedStore);
    await this.selectAppliedFilterOrNone();
  }

  /**
   * On open, only pre-select a filter when it is currently applied to the grid
   * for this category; otherwise leave selection empty.
   */
  private async selectAppliedFilterOrNone(): Promise<void> {
    const applied = await firstValueFrom(this.store.select(selectAppliedAdvancedFilterGroup));
    const matchesCategory = !!applied
      && matchesAdvancedFilterGridCategory(applied.grid, this.gridReference);
    this.store.dispatch(setSelectedAdvancedFilterGroup({
      advancedFilterGroup: matchesCategory ? applied : null,
    }));
  }

}
